// OrderAPi.js

import apiServices from "../common/apiServices";

 // Define the tag types related to entication
export const addTagTypes = [ 'Order'];

// Enhance the base API service by adding entication-related tag types
const OrderAPi = apiServices
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      // Create a new 
        createOrder: build.mutation({
            query: ({ user_id,Cart}) => ({
              url: `/ordersx/${user_id}`,
              method: 'POST',
              data:Cart, // Send an empty object
            }),
            invalidatesTags: ['Order'],  // Invalidate ShopProfiles tags after creation
          }),
      // Fetch Order query (GET request to /me)
      getOrderByUser: build.query({
        query: (userId) => ({
          url: `/ordersx/user/${userId}`,
        }),
        providesTags: ['Order'],
      }),  

      getPendingOrderByUser: build.query({
        query: ({ userId, page = 0, size = 5, orderNumber = '' }) => {
          const params = { page, size };
          if (orderNumber) {
            params.orderNumber = orderNumber;
          }
          return {
            url: `/ordersx/pending/${userId}`,
            method: 'GET',
            params,
          };
        },
        providesTags: ['Order'],
      }),
      getProcessingOrderByUser: build.query({
        query: ({ userId, page = 0, size = 5, orderNumber = '' }) => {
          const params = { page, size };
          if (orderNumber) {
            params.orderNumber = orderNumber;
          }
          return {
            url: `/ordersx/processing/${userId}`,
            method: 'GET',
            params,
          };
        },
        providesTags: ['Order'],
      }),
      getFailedOrderByUser: build.query({
        query: ({ userId, page = 0, size = 5, orderNumber = '' }) => {
          const params = { page, size };
          if (orderNumber) {
            params.orderNumber = orderNumber;
          }
          return {
            url: `/ordersx/rejected/${userId}`,
            method: 'GET',
            params,
          };
        },
        providesTags: ['Order'],
      }),
      getSuccessOrderByUser: build.query({
        query: ({ userId, page = 0, size = 5, orderNumber = '' }) => {
          const params = { page, size };
          if (orderNumber) {
            params.orderNumber = orderNumber;
          }
          return {
            url: `/ordersx/received/${userId}`,
            method: 'GET',
            params,
          };
        },
        providesTags: ['Order'],
      }),
      
      getOrderBySeller: build.query({
        query: (userId) => ({
          url: `/cart-items/sellerDto/${userId}`,
        }),
        providesTags: ['Order'],
      }),  

      getPendingCartCountBySeller: build.query({
        query: (sellerId) => ({
          url: `/cart-items/pending/count/${sellerId}`, // Adjusted the endpoint for clarity
        }),
        providesTags: ['Order'],
      }),
      
      getPendingOrdersCustomerBySeller: build.query({
        query: ({ sellerId, orderNumber = '', page = 0, size = 5 }) => {
          const params = { sellerId, page, size };
          if (orderNumber) {
            params.orderNumber = orderNumber;
          }
          return {
            url: `/cart-items/pending-orders-customer`,
            method: 'GET',
            params,
          };
        },
        providesTags: ['Order'],
      }),
      
      getProcessedOrdersCustomerBySeller: build.query({
        query: ({ sellerId, orderNumber = '', page = 0, size = 5 }) => {
          const params = { sellerId, page, size };
          if (orderNumber) {
            params.orderNumber = orderNumber;
          }
          return {
            url: `/cart-items/processing-orders-customer`,
            method: 'GET',
            params,
          };
        },
        providesTags: ['Order'],
      }),
      
      getFailedOrdersCustomerBySeller: build.query({
        query: ({ sellerId, orderNumber = '', page = 0, size = 5 }) => {
          const params = { sellerId, page, size };
          if (orderNumber) {
            params.orderNumber = orderNumber;
          }
          return {
            url: `/cart-items/rejected-orders-customer`,
            method: 'GET',
            params,
          };
        },
        providesTags: ['Order'],
      }),

      getSuccessOrdersCustomerBySeller: build.query({
        query: ({ sellerId,orderNumber='', page = 0, size = 5 }) => {
          const params = { sellerId,page, size };
          if (orderNumber) {
            params.orderNumber = orderNumber;
          }
          return {
            url: `/cart-items/received-orders-customer`,
            method: 'GET',
            params,
          };
        },
        providesTags: ['Order'],
      }),

        // Fetch Count of Distinct Carts and Total Price by Seller ID and Status
        getOrderStatusTotalByUserId: build.query({
          query: ({ userId, isActive }) => ({
            url: `/ordersx/status-counts-isActive-total`,
            params: { userId, isActive }, // Pass query parameters
          }),
          providesTags: ['Order'],
        }),

        getOrderStatusTotalByUserIdByDay: build.query({
          query: ({ userId, isActive }) => ({
            url: `/ordersx/counts-isActive-total-day`,
            params: { userId, isActive }, // Pass query parameters
          }),
          providesTags: ['Order'],
        }),

        getOrderStatusTotalByUserIdByMonth: build.query({
          query: ({ userId, isActive }) => ({
            url: `/ordersx/counts-isActive-total-month`,
            params: { userId, isActive }, // Pass query parameters
          }),
          providesTags: ['Order'],
        }),

        getOrderStatusTotalByUserIdByYear: build.query({
          query: ({ userId, isActive }) => ({
            url: `/ordersx/counts-isActive-total-year`,
            params: { userId, isActive }, // Pass query parameters
          }),
          providesTags: ['Order'],
        }),
      
       // Fetch Order query (GET request to /me)
       getOrder: build.query({
        query: () => ({
          url: `/orders`,
        }),
        providesTags: ['Order'],
      }),  
       // Deactivate Cart mutation (PUT request to /{id}/deactivate)
       deactivateCart: build.mutation({
        query: (id) => ({
          url: `/ordersx/${id}/deactivate`,
          method: 'PUT',
        }),
        invalidatesTags: ['Order'], // Invalidate Order tags after updating
      }),
       // Delete   mutation (DELETE request  )
       deleteOrder: build.mutation({
        query: (id) => ({
          url: `/orders/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Order'], // Invalidate the user tag after deletion
      }),
    }),
    overrideExisting: false,
  });

export default OrderAPi;

// Exporting hooks for each endpoint to be used in components
export const {
    useCreateOrderMutation,
    useGetOrderByUserQuery,
    useGetPendingOrderByUserQuery,
    useGetProcessingOrderByUserQuery,
    useGetFailedOrderByUserQuery,
    useGetSuccessOrderByUserQuery,
    useGetOrderBySellerQuery,
    useGetPendingOrdersCustomerBySellerQuery,
    useGetProcessedOrdersCustomerBySellerQuery,
    useGetFailedOrdersCustomerBySellerQuery,
    useGetSuccessOrdersCustomerBySellerQuery,
    useGetOrderQuery,
    useDeleteOrderMutation,
    useDeactivateCartMutation,

    useGetOrderStatusTotalByUserIdQuery,
    useGetOrderStatusTotalByUserIdByDayQuery,
    useGetOrderStatusTotalByUserIdByMonthQuery,
    useGetOrderStatusTotalByUserIdByYearQuery,
    useGetPendingCartCountBySellerQuery,
    useGet
} = OrderAPi;

